import { IconButton, Stack, TextField, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React from 'react';

import Iconify from 'components/Iconify';
import useLocales from 'hooks/useLocales';
import { fDate } from 'utils/formatTime';

// ----------------------------------------------------------------------

type Props = {
    date: Date;
    onNextDate: VoidFunction;
    onPrevDate: VoidFunction;
    onChangeDate: (date: Date | null) => void;
};

export default function CalendarToolbar({ date, onNextDate, onPrevDate, onChangeDate }: Props) {
    const { translate, currentLang } = useLocales();

    return (
        <>
            <Stack direction='row' alignItems='center' justifyContent='space-between' sx={{ p: 2.5, pr: 2 }}>
                <Stack direction='row' alignItems='center' spacing={1}>
                    <DatePicker
                        views={['year']}
                        label={translate('select_year')}
                        value={date}
                        onChange={onChangeDate}
                        renderInput={params => <TextField {...params} />}
                    />
                </Stack>
                <Stack direction='row' alignItems='center' spacing={1}>
                    <IconButton onClick={onPrevDate}>
                        <Iconify icon='eva:arrow-ios-back-fill' />
                    </IconButton>

                    <Stack direction='column' alignItems='center'>
                        <Typography variant='h6' sx={{ textTransform: 'capitalize' }}>
                            {fDate(date, currentLang.value, 'LLLL')}
                        </Typography>
                    </Stack>

                    <IconButton onClick={onNextDate}>
                        <Iconify icon='eva:arrow-ios-forward-fill' />
                    </IconButton>
                </Stack>

                <Stack direction='row' alignItems='center' spacing={1}></Stack>
            </Stack>
        </>
    );
}
